exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.well[data-v-0979a1fc] {\n  margin-top: 20px;\n}\n", ""]);

// exports
